import React from 'react';

const DocumentNew = props => (
    <svg viewBox="0 0 22 22" {...props}>
        <path d="M2,0 L2,13.999 L4,13.999 L4,2 L14.001,2 L14.001,7.999 L20,7.999 L20,18 L8,18 L8,20 L22,20 L22,6.079 L16,0 L2,0 Z M2,15.999 L2,18 L0,18 L0,20 L2,20 L2,22 L4,22 L4,20 L6.001,20 L6.001,18 L4,18 L4,15.999 L2,15.999 Z" />
    </svg>
);

export default DocumentNew;
